console.log("init Proteus treatments -- 2.02");

proteus.add_cartAttribute("proteus-shipping", "[KIZ-128]v1")

window.dataLayer = window.dataLayer || [];

// BIS events
observeSelector('.klaviyo-bis-trigger', bis => {
  bis.addEventListener("click", () => {

    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': `BIS click`,
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });

  });
})

// postscript popup analytics
window.addEventListener("postscriptPopup", function(e) {
  console.log("POSTSCRIPT FULL", e);
  const detail = e?.detail;
  if (!detail || typeof detail !== "object" || !detail.type) return;
  console.log("POSTSCRIPT EVENT", detail);

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': `PS ${e.detail.type} -- ${e.detail.popupId}`,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });
});

window.addEventListener("klaviyoForms", function(e) { 

  // console.log("KL events", e)
  
  let form_id = e.detail.formId;
  let test_var = e.detail.formVersionId;
  
  if (e.detail.type == 'submit') {
    
    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': `KL ${form_id} submit ${test_var}`,
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });
    
    // console.log("KL SUBMIT", form_id);
    
  } else if (e.detail.type == 'stepSubmit') {
    
    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': `KL ${form_id} stepSubmit ${test_var}`,
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });
    
    // console.log("KL STEP", form_id);
    
  } else if (e.detail.type == 'open') {
    
    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': `KL ${form_id} open ${test_var}`,
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });
    
    // console.log("KL STEP", form_id);
    
  } else {
    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': `KL ${form_id} ${e.detail.type} ${test_var}`,
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });
  }
  
});

window.first_selected_logic = false;

// support for proteus pp_offers
if(window.location.href.indexOf("qa=pp") > -1){
  window.sessionStorage.setItem("Proteus PP QA", true);
}

const push_pp_offers = () => {
  if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

    let session_id = window.sessionStorage.getItem("Proteus pp-session-id");
    fetch("https://admin-api-kiz.fly.dev/api/pp_offers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        referenceId: session_id,
        offers: window.cart_pp_offers
      })
    }).then(res => res.json()).then(console.log).catch(console.error);

  }
};

setTimeout(() => {
  if(!window.sessionStorage.getItem("Proteus pp-session-id")){ // && window.sessionStorage.getItem("Proteus PP QA")
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}, 500); // delay to reduce API clogging

async function get_proteus_product_data(prod_id) {
  console.log("get_proteus_product_data()");
  // could potentially do this via Shopify REST API
  const response = await fetch(`https://admin-api-kiz.fly.dev/api/catalog?lookup=product_alt&id=${prod_id}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}


document.addEventListener("cart:change", (e) => {

  console.log("pp cart_change", e.detail);

  for(let i = 0; i < e.detail.cart.items.length; i++){
    
    let prod_id = e.detail.cart.items[i].product_id;
    let var_id = e.detail.cart.items[i].variant_id;

    console.log("pp cart change checking", prod_id, window.cart_pp_offers.some(obj => obj.pp_offer_id === prod_id))

    if(!window.cart_pp_offers.some(obj => obj.pp_offer_id == prod_id)){ // && window.cart_pp_offers.length == 0
      get_proteus_product_data(prod_id).then(data => {
        
        console.log("data", data);

        let prod_title = data.product.title.toLowerCase();
        let var_data = data.product.variants.edges.find(obj => obj.node.id.indexOf(var_id) > -1);

        if(var_data && prod_title.indexOf("gift card") == -1){
          
          let price = parseFloat(var_data.node.price);
          let compare_at_price = parseFloat(var_data.node.comparAtPrice);

          if(compare_at_price > price){

            window.cart_pp_offers.push({
              "pp_offer_id": prod_id,
              "pp_offer_banner_title": "It's not too late to add another to your order and save!",
              "pp_offer_banner_subtitle": "",
              "pp_offer_title": data.product.title,
              "pp_offer_image_url": data.product.featuredImage.url,
              "pp_offer_description": [
                var_data.node.title
              ],
              "pp_offer_compare_at": (compare_at_price).toFixed(2),
              "pp_offer_price": (price).toFixed(2),
              "changes": [{
                "type": "add_variant",
                "variantId": var_id,
                "quantity": 1,
                "discount": {
                  "value": 0,
                  "valueType": "percentage",
                  "title": "0% off post purchase"
                }
              }]
            });

          } else {

            window.cart_pp_offers.unshift({
              "pp_offer_id": prod_id,
              "pp_offer_banner_title": "Add another pair to your order and save!",
              "pp_offer_banner_subtitle": "Get 15% Off",
              "pp_offer_title": data.product.title,
              "pp_offer_image_url": data.product.featuredImage.url,
              "pp_offer_description": [
                var_data.node.title
              ],
              "pp_offer_compare_at": (price).toFixed(2),
              "pp_offer_price": (price * .85).toFixed(2),
              "changes": [{
                "type": "add_variant",
                "variantId": var_id,
                "quantity": 1,
                "discount": {
                  "value": 15,
                  "valueType": "percentage",
                  "title": "15% off post purchase"
                }
              }]
            });

          }

        }

      })
    }

  }

  push_pp_offers()
  
})

// support for first selected option on PDP
if(window.location.href.indexOf("/products/") > -1 && window.first_selected_logic && window.location.href.indexOf("first_selected=native") == -1){
  // is PDP
  if(window.location.href.indexOf("variant=") == -1 && 
  window.location.href.indexOf("?exempt") == -1){

    // variant is not already selected
    waitForElement('[class*="variant-picker"] input[data-is-default="true"]').then(default_option => {

      // kick the options so the theme renders availability

      let attempts_count = 0;
      const interval = setInterval(() => {
        
        attempts_count ++;
        console.log("attempts_count", attempts_count);

        default_option.checked = true;
        default_option.dispatchEvent(new Event("change", { bubbles: true }));

        if(document.querySelectorAll('label.block-swatch.is-disabled').length > 0 || attempts_count >= 10){ //4s
          
          document.querySelector('[class*="variant-picker"] input[data-is-default="true"]').checked = false;

          waitForElement('.product-info__variant-picker .variant-picker__option-info span').then(selected_label => {
            selected_label.remove();
          }).catch();
          
          waitForElement('buy-buttons[form*="product-form"] button').then(atc_button => {
            atc_button.disabled = true;
            atc_button.querySelector('div').innerHTML = "Select Size";
          }).catch();

          clearInterval(interval);

        }

      }, 200);

    }).catch()
  }
}

// window.show_deals = {{ settings.show_deals }}
// window.localStorage.getItem("closeout_pdp_viewed"); // set in theme.liquid
if(window.location.href.indexOf("show-deals=true") > -1 || window.localStorage.getItem("closeout_pdp_viewed")){
  console.log("reveal closeout items");
  waitForElement('body').then(doc => {
    doc.setAttribute("closeout-shown", true);
  }).catch();
}

// fallback if there are no non-closeout options
waitForElement('.product-info__product-picker .variant-picker').then(picker => {
  if(document.querySelectorAll('.product-info__product-picker .variant-picker').length == 1 &&
  picker.classList.value.indexOf("is-closeout") > -1){
    picker.style.display = "block";
  }
}).catch();

const mark_selected_colors_as_checked = () => {

  console.log("mark_selected_colors_as_checked()") 

  setTimeout(() => {

    let current_params = new URLSearchParams(window.location.search);
    let selected_colors = current_params.getAll('filter.p.m.custom.color');

    selected_colors.forEach(color => {

      let input = document.querySelector(
        `#facet-form[update-on-change] input[name="filter.p.m.custom.color"][value="${CSS.escape(color)}"]`
      );
      if (input) {
        input.checked = true;
      }
    });

  }, 500)

}

document.addEventListener("facet:update", () => {
    mark_selected_colors_as_checked()
})

// init 
mark_selected_colors_as_checked();
// KIZ-146 — native Review Summary card (snippets/product-info.liquid, block 'review_summary').
// Document-level delegation on purpose: the card lives inside <product-rerender>, whose re-render
// sanitizes injected HTML (inline <script> and unknown custom elements are stripped).
document.addEventListener('click', function (e) {
  var card = e.target && e.target.closest ? e.target.closest('.kiz-rsum') : null;
  if (!card) return;
  var target = document.querySelector('.stamped-main-widget, #stamped-main-widget, [id*="stamped_reviews_main_widget"]');
  if (!target) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
});
